import React from 'react';
import Builder from '../Builder/Section';
export var FullmapCover = Builder({
  className: 'full-map__cover',
  render: function render(_ref) {
    var place = _ref.place,
        _ref$zoom = _ref.zoom,
        zoom = _ref$zoom === void 0 ? 10 : _ref$zoom;
    return /*#__PURE__*/React.createElement("div", {
      className: "full-map__map has-iframe",
      id: "full-map--googleid"
    }, /*#__PURE__*/React.createElement("iframe", {
      title: "Google Maps",
      width: "100%",
      height: "100%",
      frameBorder: "0",
      src: "https://www.google.com/maps/embed/v1/place?key=" + process.env.GOOGLE_MAPS_API_KEY + "&q=" + encodeURIComponent(place) + "&zoom=" + zoom,
      allowFullScreen: true
    }));
  }
});
export var FullmapWrap = Builder({
  className: 'full-map__wrap'
});
export var Fullmap = Builder({
  tagName: 'section',
  className: 'full-map'
});